"use strict";

var _LandingDesktop, _AsyncBoundary;
import { useResponsiveValue } from '@autoguru/overdrive';
import { AsyncBoundary } from '@autoguru/suspense';
import { useEffect } from 'react';
import { LandingDesktop } from './LandingDesktop';
import { LandingMobile } from './LandingMobile';
import { jsx as _jsx } from "react/jsx-runtime";
export const HomeComponent = () => {
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage('logged-out', '*');
    }
  }, []);
  const isDesktop = useResponsiveValue([false, true]);
  return isDesktop ? _LandingDesktop || (_LandingDesktop = /*#__PURE__*/_jsx(LandingDesktop, {})) : _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: null,
    children: /*#__PURE__*/_jsx(LandingMobile, {})
  }));
};